import React, {useEffect, useRef, useState} from 'react';
import "./Create.css";

import {loadStripe} from '@stripe/stripe-js';
import { useLongPress } from 'use-long-press';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

import Snapshot from "../../../Models/Snapshot";
import Floorplan from "../../../Models/Floorplan";
import Project from "../../../Models/Project";
import Folder from "../../../Models/Folder";
import MapItButton from '../../Common/MapItButton/MapItButton';
import * as Security from '../../Security/Security';
import * as Network from '../../Network/Network';

import uploadIcon from '../../../Assets/MapIt-Upload-Icon.png';
import * as Loader from 'react-spinners';

import PageTitle from '../../Common/PageTitle/PageTitle';
import {Helmet} from "react-helmet";
// import ImageGallery from "react-image-gallery";

import { Link } from 'react-router-dom';
// import "react-image-gallery/styles/css/image-gallery.css";

import left from '../../../Assets/left-arrow.png';
import right from '../../../Assets/right-arrow.png';
import leftBlue from '../../../Assets/left-arrow-blue.png';
import rightBlue from '../../../Assets/right-arrow-blue.png';

const Create = ({fpBase64, 
  setFpBase64, 
  ssObjs, 
  setSSObjs, 
  fpWidth, 
  setFpWidth, 
  fpHeight,
  setFpHeight, 
  file, 
  setFile, 
  setPreview, 
  fpX, 
  setFpx, 
  fpY, 
  setFpy, 
  fpType, 
  setFpType, 
  snapSize, 
  setSnapSize,
  fpOgWidth,
  setFpOgWidth,
  setFpOgHeight,
  fpOgHeight,
  sharePressed,
  setSharePressed,
  user,
  setUser,
  setSubPlan,
  setRegMode,
  setFpObj,
  address,
  setAddress,
  email,
  setEmail,
  coordMap,
  setCoordMap,
  galMap,
  setGalMap,
  selectedCoord,
  setSelectedCoord,
  mapOfX,
  setMapOfX,
  sortedByX,
  setSortedByX}) => {
  const [loading, setLoading] = useState(false);
  const [selectedSS, setSelectedSS] = useState(0);
  const [longPress, setLongPress] = useState(false);
  const [ssDelActi, setSSDelActi] = useState(false);
  const [ssIdx, setSSIdx] = useState(-1);
  const [ssViewActive, setSSViewActive] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [ssDoubleClicked, setSSDoubleClicked] = useState(0);
  const [isFpPdf, setIsFpPdf] = useState(false);
  const [folders, setFolders] = useState({});
  const [fIdx, setFIdx] = useState(-1);

  const selectedCoordRef = useRef(selectedCoord);
  const popupRef = useRef();
  const fpRef = useRef();
  const btnRef = useRef();
  const galRef = useRef();
  const doubleClickRef = useRef(ssDoubleClicked);
  const ssObjsRef = useRef(ssObjs);

  let navigate = useNavigate();

  const prod_host = "https://server.mapit.cc";

  // const stripeProductKey = "pk_test_51P7G7WAAPuhdwRL35ymriOpqNPcTQy2S8cW7jxv4dVY1lgHBnatmUk3a9RgvQcQ5Z5xIbzB8Lf6VajWl6NGNE5ZQ00QQG5q47y";
  const stripeProductKey = "pk_live_51P7G7WAAPuhdwRL3ItOHsgW1Ds2UmF7bYPmECSg1tg125aqxvrweluh30wcmAfUaoHQ2HsefcdkndXb1oYBTeKXF00qmntGvir";

  useEffect(() => {
    if (user && Object.keys(user).length != 0) {
      updateUserObj();
    }
    const closePopup = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        setSharePressed(false);
      }
      if (galRef.current && !galRef.current.contains(e.target)) {
        setSSDoubleClicked(0);
        console.log(`doubleclickref ${doubleClickRef.current}`);
        console.log("ssobjs in closeup");
        console.log(ssObjsRef.current);
        const ss = ssObjsRef.current[doubleClickRef.current];
        console.log("ss obj in closepopup");
        console.log(ss);
        selectedCoordRef.current[`coordX: ${ss.coordinatex} coordY: ${ss.coordinatey}`] = 0;
        setSelectedCoord({...selectedCoordRef.current});
      }
      // if (!sharePressed 
      //   && selectedSS !==0
      //   && fpRef.current 
      //   && !fpRef.current.contains(e.target) 
      //   && btnRef.current 
      //   && !btnRef.current.contains(e.target)) {
      //     setSelectedSS(0);
      //   }
    }
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
      // let width = fpWidth*windowWidth/0.8;
      // let height = fpHeight*windowHeight/0.8;
      // const dimObj = getFrameDim (height, width, window.innerHeight, window.innerWidth);
      // let fpx = ((window.innerWidth - 0.8*dimObj.width)/2)/window.innerWidth;
      // let fpy = ((window.innerHeight - 0.8*dimObj.height)/2)/window.innerHeight;
      // setFpWidth(0.8*dimObj.width/window.innerWidth);
      // setFpHeight(0.8*dimObj.height/window.innerHeight);
      // setFpx(fpx);
      // setFpy(fpy);
    };
    const handlePopState = (event) => {
      // You can add logic here to check event details if needed
      resetCreateState();
    };
    document.body.addEventListener('mousedown', closePopup);
    window.addEventListener('resize', handleResize);
    window.addEventListener('popstate', handlePopState);
    return () => {
      document.body.removeEventListener('mousedown', closePopup);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  useEffect(()=>{
    ssObjsRef.current = ssObjs;
  },[ssObjs]);

  useEffect(()=> {
    doubleClickRef.current = ssDoubleClicked;
  },[ssDoubleClicked]);

  useEffect(()=>{
    selectedCoordRef.current = selectedCoord;
  },[selectedCoord]);

  const updateUserObj = () => {
      Network.getUserSub(user.email, function (err, result) {
        if (err) {
          console.log(err);
          console.log("user obj did not get updated");
        } else {
          // update user object
          if (user.sub_plan !== result.sub_plan) {
            setUser({...user, sub_plan: result.sub_plan, sub_cancel_pending: ""});
          } else {
            console.log(`no update occurred`);
          }
        }
      });
  }

  const getLeftArrowStyle = (ssId) => {
    let width = getSSWidth(ssId);
    let height = getSSHeight(ssId);
    let arrowWidth = width*0.15;
    let arrowHeight = arrowWidth*1.74;
    return {position: 'absolute',
    width: arrowWidth,
    height: height,
    left: ((fpX*windowWidth) + (ssObjs[ssId].coordinatex*fpWidth*windowWidth) + leftOrRight(ssId)), 
    top: ((fpY*windowHeight) + (ssObjs[ssId].coordinatey*fpHeight*windowHeight) + topOrBottom(ssId)),
    };
  }
  const getRightArrowStyle = (ssId) => {
    let width = getSSWidth(ssId);
    let height = getSSHeight(ssId);
    let arrowWidth = width*0.15;
    let arrowHeight = arrowWidth*1.74;
    return {position: 'absolute',
    width: arrowWidth,
    height: height,
    left: ((fpX*windowWidth) + (ssObjs[ssId].coordinatex*fpWidth*windowWidth) + leftOrRight(ssId) + (width) - arrowWidth), 
    top: ((fpY*windowHeight) + (ssObjs[ssId].coordinatey*fpHeight*windowHeight) + topOrBottom(ssId)),
    };
  }


  async function getImageDimensions(file) {
    let img = new Image();
    img.src = URL.createObjectURL(file);
    await img.decode();
    let width = img.width;
    let height = img.height;
    return {
        width,
        height,
    }
  }

  async function getImageDimBase64 (base64) {
    let img = new Image();
    img.src = base64;
    await img.decode();
    let width = img.width;
    let height = img.height;
    return {
        width,
        height,
    }
  }

 function convertPdfToJpg (base64) {
  return new Promise ((resolve,reject) => {
    setLoading(true);
    fetch(`${prod_host}/pdfToJpg`, {
      method: 'post',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
          b64: base64,
      })
    })
    .then(response => response.json())
    .then(serverResponse => {
      setLoading(false);
      resolve(serverResponse);
    })
    .catch ((err) => {
      setLoading(false);
      reject(err);
    });
  });
}

function isUnderFileLimit (size) {
  const oneMB = 1048576;
  const oneKB = 1024;
  if (size < 10*oneMB) {
    return true;
  } else {
    return false;
  }
}

  async function handleChange(event) {
    console.log(event.target.files[0]);
    setLoading(true);
    let base64Str = "";
    console.log("File Type: ");
    const base64 = await convertBase64(event.target.files[0]);
    console.log(base64.substring(0,100));
    if (isUnderFileLimit(event.target.files[0].size)) {
      if (event.target.files[0].type === "application/pdf") {
        base64Str = base64.split("data:application/pdf;base64,")[1];
        const pdfToImgData = await convertPdfToJpg(base64Str);
        const {width, height} = await getImageDimBase64("data:image/jpeg;base64," + pdfToImgData);
        setFpOgWidth(width);
        setFpOgHeight(height);
        const dimObj = getFrameDim (height, width, window.innerHeight, window.innerWidth);
        setFpBase64(pdfToImgData);
        setFpType("jpeg");
        let fpx = ((windowWidth - 0.8*dimObj.width)/2)/windowWidth;
        let fpy = ((windowHeight - 0.8*dimObj.height)/2)/windowHeight;
        setFpWidth(0.8*dimObj.width/windowWidth);
        setFpHeight(0.8*dimObj.height/windowHeight);
        setFpx(fpx);
        setFpy(fpy);
        setFile(URL.createObjectURL(event.target.files[0]));
        setLoading(false);
      } else {
        // const fileType = getFileType()
        let base64Token = "";
        if (event.target.files[0].type === "image/png") {
          base64Token = "data:image/png;base64,";
          setFpType("png");
        } else if (event.target.files[0].type === "image/jpg" || event.target.files[0].type === "image/jpeg") {
          base64Token = "data:image/jpeg;base64,";
          setFpType("jpeg");
        } else {
          console.log("file type not supported");
        }
        base64Str = base64.split(base64Token)[1];
        const {width, height } = await getImageDimensions(event.target.files[0]);
        setFpOgWidth(width);
        setFpOgHeight(height);
        const dimObj = getFrameDim (height, width, window.innerHeight, window.innerWidth);
        let fpx = ((windowWidth - 0.8*dimObj.width)/2)/windowWidth;
        let fpy = ((windowHeight - 0.8*dimObj.height)/2)/windowHeight;
        setFpBase64(base64Str);
        setFile(URL.createObjectURL(event.target.files[0]));  
        setFpWidth(0.8*dimObj.width/windowWidth);
        setFpHeight(0.8*dimObj.height/windowHeight);
        setFpx(fpx);
        setFpy(fpy);
        setLoading(false);
      }
    } else {
      setLoading(false);
      toast.error("Invalid File Size", {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    }
  }

  async function handleMultipleChange(event) {
    let ssObjList = {};
    let ssId = ssIdx;
    const loopSize = 40 - Object.keys(ssObjs).length;
    setLoading(true);
    for (let idx = 0; idx < Math.min(event.target.files.length, loopSize); idx++) {
      let file = event.target.files[idx];
      if (isUnderFileLimit(file.size)) {
        const base64 = await convertBase64(file);
        let fileType = "";
        let base64Token = "";
        if (file.type === "image/png") {
          base64Token = "data:image/png;base64,";
          fileType = "png";
        } else if (file.type === "image/jpg" || file.type === "image/jpeg") {
          base64Token = "data:image/jpeg;base64,";
          fileType = "jpeg";
        } else {
          console.log("file type not supported");
        }
        let base64Str = base64.split(base64Token)[1];
        const {width, height } = await getImageDimensions(file);
        const dimObj = getFrameDim (height, width, windowHeight, windowWidth);
        let urlObj = URL.createObjectURL(file);
        let ssObj = new Snapshot(ssId, base64Str, 0.0, 0.0, "", urlObj, "", width, height, fileType);
        ssObj.renderWidth = 0.8*dimObj.width/windowWidth;
        ssObj.renderHeight = 0.8*dimObj.height/windowHeight;
        ssObjList[ssId] = ssObj;
        ssId = ssId - 1;
      } else {
        toast.error("Invalid File Size", {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        })
      }
    }
    setLoading(false);
    setSSIdx(ssId - 1);
    setSSObjs({...ssObjs, ...ssObjList});
  }

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file)
      fileReader.onload = () => {
        resolve(fileReader.result);
      }
      fileReader.onerror = (error) => {
        reject(error);
      }
    });
  }

  const imageClick = (ssObj, index) => {
    if (longPress) {
      console.log(`long press for ssid: ${index}`);
      // render snapshot delete view
      setSSDelActi(true);
      setLongPress(false);
    }
    if (index === selectedSS) {
      setSelectedSS(0)
    } else {
      setSelectedSS(index);
    }
  }

  const bind = useLongPress(() => {
      setLongPress(true);
  });

  const genMapOfX = (snapshots) => {
    let ssList = [];
    for (const [key,ss] of Object.entries(snapshots)) {
      if (ss.coordinatex!=0 || ss.coordinatey!=0) {
        ssList.push(ss);
      }
    }
    const sortedX = ssList.toSorted((a,b)=> {
      if (a.coordinatex!==b.coordinatex) {
        return a.coordinatex-b.coordinatex;
      }
      return a.snapshot_id-b.snapshot_id;
    });
    let mapOfX = {};
    sortedX.forEach((ss,index) => {
      mapOfX[ss.snapshot_id] = index; 
    });
    setSortedByX(sortedX);
    setMapOfX(mapOfX);
  }

  const checkIfInRadius = (coordX, coordY) => {
    for (const ssId in ssObjs) {
      const ssObj = ssObjs[ssId];
      if (ssId !== selectedSS) {
        if (Math.abs(ssObj.coordinatex - coordX) < 0.05 && Math.abs(ssObj.coordinatey-coordY) < 0.05) {
          return [ssObj.coordinatex, ssObj.coordinatey];
        }
      }
    }
    return [-1,-1]
  }

  const fpClick = (event) => {
    if (event.type === "contextmenu") {
      setSelectedSS(0);
    }
    else if (selectedSS != 0) {
      console.log(`pagex: ${event.pageX}`);
      console.log(`pagey: ${event.pageY}`);
      console.log(`clientx: ${event.clientX}`);
      console.log(`clienty: ${event.clientY}`);
      console.log(`offsetx: ${event.offsetX}`);
      console.log(`offsety: ${event.offsetY}`);
      // console.log(`fpY height: ${fpY*windowHeight}`);
      // console.log(`fpX width: ${fpX*windowWidth}`);
      // console.log(`fpWidth: ${fpWidth*windowWidth}`);
      // console.log(`fpHeight: ${fpHeight*windowHeight}`);

      // setSSObjs[selectedSS].coordinatex = event.clientX;
      // setSSObjs[selectedSS].coordinatey = event.clientY;
      let coordX = (event.pageX-(fpX*windowWidth)-(getSSWidth(selectedSS)/2))/(fpWidth*windowWidth);
      let coordY = (event.pageY-(fpY*windowHeight)-(getSSHeight(selectedSS)/2))/(fpHeight*windowHeight);
      console.log(`coordx: ${(event.pageX-(fpX*windowWidth))/(fpWidth*windowWidth)}`);
      console.log(`coordy: ${(event.pageY-(fpY*windowHeight))/(fpHeight*windowHeight)}`);
      const [x,y] = checkIfInRadius(coordX, coordY);
      if (x !== -1) {
        coordX = x;
        coordY = y;
      }
      if (coordMap[`coordX: ${ssObjs[selectedSS].coordinatex} coordY: ${ssObjs[selectedSS].coordinatey}`]) {
        coordMap[`coordX: ${ssObjs[selectedSS].coordinatex} coordY: ${ssObjs[selectedSS].coordinatey}`] = coordMap[`coordX: ${ssObjs[selectedSS].coordinatex} coordY: ${ssObjs[selectedSS].coordinatey}`] - 1;
        galMap[`coordX: ${ssObjs[selectedSS].coordinatex} coordY: ${ssObjs[selectedSS].coordinatey}`].pop();
      }
      ssObjs[selectedSS].coordinatex = coordX;
      ssObjs[selectedSS].coordinatey = coordY;
      if (coordMap[`coordX: ${coordX} coordY: ${coordY}`]) {
        coordMap[`coordX: ${coordX} coordY: ${coordY}`] = coordMap[`coordX: ${coordX} coordY: ${coordY}`] + 1;
        galMap[`coordX: ${coordX} coordY: ${coordY}`].push({original: getImageSrc(ssObjs[selectedSS]), ssId: selectedSS});
      } else {
        coordMap[`coordX: ${coordX} coordY: ${coordY}`] = 1;
        galMap[`coordX: ${coordX} coordY: ${coordY}`] = [{original: getImageSrc(ssObjs[selectedSS]), ssId: selectedSS}];
        selectedCoord[`coordX: ${coordX} coordY: ${coordY}`] = 0;
      }
      setSelectedCoord({...selectedCoord});
      setGalMap({...galMap})
      setCoordMap({...coordMap});
      console.log(coordMap);
      setSSObjs({...ssObjs});
      genMapOfX(ssObjs);
    }
    else {
      console.log("attempting to create folder")
      const coordX = (event.pageX-(fpX*windowWidth)-(getSSWidth(selectedSS)/2))/(fpWidth*windowWidth);
      const coordY = (event.pageY-(fpY*windowHeight)-(getSSHeight(selectedSS)/2))/(fpHeight*windowHeight);

      console.log(coordX);
      console.log(coordY);
      console.log(folders)
      const newFolder = new Folder (fIdx, "", -1*fIdx, coordX, coordY);
      setFolders({...folders, [fIdx]: newFolder});
      setFIdx(fIdx-1);
      // selectedSS is 0. Meaning no ss has been selected. In this case we place an anchor.
      // create folder list
    }
    // from the event object we can get the coordiante of the click
    // use the coordinates to set the coordinates on the selcted image
  }

  const getFrameDim = (height, width, maxHeight, maxWidth) => {
    // console.log("In getFrameDim");
    // console.log(maxWidth);
    // console.log(maxHeight);
    // console.log(width);
    // console.log(height);
    if (!width) width = maxWidth;
    if (!height) height = maxHeight;
    if (width > maxWidth && height > maxHeight) {
    //   console.log(width);
    //   console.log(height);
      let wDiff = (width - maxWidth)/width;
      let hDiff = (height - maxHeight)/height;
      if (wDiff >= hDiff) {
        height = (1-wDiff)*height;
        width = (1-wDiff)*width;
      } else {
        height = (1-hDiff)*height;
        width = (1-hDiff)*width;
      }
    } else if (width > maxWidth) {
      let wDiff = (width - maxWidth)/width;
      width = (1-wDiff)*width;
      height = (1-wDiff)*height;
    } else if (height > maxHeight) {
      let hDiff = (height - maxHeight)/height;
      height = (1-hDiff)*height;
      width = (1-hDiff)*width;
    } else {
      // width and height must be less than the screen width and height
      let wDiff = (maxWidth - width)/width;
      let hDiff = (maxHeight - height)/height;
      if (wDiff >= hDiff) {
        height = (1+hDiff)*height;
        width = (1+hDiff)*width;
      } else {
        height = (1+wDiff)*height;
        width = (1+wDiff)*width;
      }
    }
    // console.log(`Debug Log: new width: ${width}`)
    // console.log(`Debug Log: new height: ${height}`)
    return {width: width, height: height}
  }

  const leftOrRight = (ssId) => {
    if (((fpX*windowWidth) + (ssObjs[ssId].coordinatex*fpWidth*windowWidth) + ssObjs[ssId].renderWidth*windowWidth*0.4)
    > (fpX*windowWidth+(fpWidth*windowWidth))) {
      return -1*ssObjs[ssId].renderWidth*windowWidth*0.4+(fpWidth*windowWidth*snapSize); // magic number 0.4? - hard type this
    } else {
      return 0;
    }
  }

  const topOrBottom = (ssId) => {
    if (((fpY*windowHeight) + (ssObjs[ssId].coordinatey*fpHeight*windowHeight) + ssObjs[ssId].renderHeight*windowHeight*0.4)
    > (fpY*windowHeight+(fpHeight*windowHeight))) {
      return -1*ssObjs[ssId].renderHeight*windowHeight*0.4+(fpWidth*windowWidth*snapSize);
    } else {
      return 0;
    }
  }

  const getSnapshotStyle = (ssId) => {
    let borderTopRight = false;
    let borderTopLeft = false;
    let borderBottomRight = false;
    let borderBottomLeft = false;
    if (ssId==ssDoubleClicked) {
      const leftOrRightVal = leftOrRight(ssId);
      const topOrBottomVal = topOrBottom(ssId);
    if (leftOrRightVal && topOrBottomVal) {
      borderBottomRight = true;
    } else if (leftOrRightVal) {
      borderTopRight = true;
    } else if (topOrBottomVal) {
      borderBottomLeft = true;
    } else {
      borderTopLeft = true;
    }
  }
    if (ssObjs[ssId].coordinatex !== 0 || ssObjs[ssId].coordinatey !== 0) {
      // console.log(`left: ${(fpX*windowWidth) + (ssObjs[ssId].coordinatex*fpWidth*windowWidth)}`);
      // console.log(`top: ${(fpY*windowHeight) + (ssObjs[ssId].coordinatey*fpHeight*windowHeight)}`);
      if (selectedCoord[`coordX: ${ssObjs[ssId].coordinatex} coordY: ${ssObjs[ssId].coordinatey}`] == 0) {
        return {position: 'absolute', 
        left: (fpX*windowWidth) + (ssObjs[ssId].coordinatex*fpWidth*windowWidth),
        top: (fpY*windowHeight) + (ssObjs[ssId].coordinatey*fpHeight*windowHeight),
        borderRadius: "50%"
        };
      } else {
        return {position: 'absolute', 
        left: ((fpX*windowWidth) + (ssObjs[ssId].coordinatex*fpWidth*windowWidth) + leftOrRight(ssId)), 
        top: ((fpY*windowHeight) + (ssObjs[ssId].coordinatey*fpHeight*windowHeight) + topOrBottom(ssId)),
        borderBottomLeftRadius:borderBottomLeft?'0px':'5px',
        borderBottomRightRadius:borderBottomRight?'0px':'5px',
        borderTopLeftRadius:borderTopLeft?'0px':'5px',
        borderTopRightRadius:borderTopRight?'0px':'5px'
        };
      }
    } else if (ssId == ssDoubleClicked) {
      console.log("double clicked");
      return {position: 'absolute', top: "50vh", left: "3.3vw"};
    } else {
      return {borderRadius: "5px"};
    }
  }

  const getSnapshotCountStyle = (ssId) => {
    if (ssObjs[ssId].coordinatex !== 0 || ssObjs[ssId].coordinatey !== 0) {
      return {position: 'absolute', color: "white", 
      backgroundColor: "red", 
      border: "1px solid red", 
      borderRadius:"50%",
      left: (fpX*windowWidth) + (ssObjs[ssId].coordinatex*fpWidth*windowWidth),
      top: (fpY*windowHeight) + (ssObjs[ssId].coordinatey*fpHeight*windowHeight)
      };
    } else {
      return {};
    }
  }

  const onDelSS = () => {
    console.log("snapshot del pressed");
    if (ssObjs[selectedSS].coordinatex == 0 && ssObjs[selectedSS].coordinatey == 0 ) {
      delete ssObjs[selectedSS];
      setSelectedSS(0);
      setSSViewActive(false);
      setSSObjs(JSON.parse(JSON.stringify(ssObjs))); // find  a better way to do this
    } else {
      const coordX = ssObjs[selectedSS].coordinatex;
      const coordY = ssObjs[selectedSS].coordinatey;
      if (coordMap[`coordX: ${coordX} coordY: ${coordY}`] > 1) {
        let imgList = galMap[`coordX: ${coordX} coordY: ${coordY}`];
        imgList.forEach((imgObj,index) => {
          delete ssObjs[imgObj.ssId];
        });
        delete galMap[`coordX: ${coordX} coordY: ${coordY}`];
      } else {
        delete ssObjs[selectedSS];
      }
      delete coordMap[`coordX: ${coordX} coordY: ${coordY}`];
      setCoordMap(JSON.parse(JSON.stringify(coordMap)));
      setGalMap(JSON.parse(JSON.stringify(galMap)));
      setSelectedSS(0);
      setSSViewActive(false);
      setSSObjs(JSON.parse(JSON.stringify(ssObjs))); // find  a better way to do this
      genMapOfX(JSON.parse(JSON.stringify(ssObjs)));
    }
  }

  const onCanSS = () => {
    console.log("snapshot cancel pressed");
    setSelectedSS(0);
    setSSViewActive(false);
    setSSDoubleClicked(0);
  }

  const onViewSS = () => {
    console.log("snapshot being viewed");
    setSSViewActive(true);
  }

  const onBackSS = () => {
    setSSViewActive(false);
  }

  const resetCreateState = () => {
    setFpOgWidth(0);
    setFpOgHeight(0);
    setFpBase64("");
    setFpType("");
    setFpWidth(0);
    setFpHeight(0);
    setFpx(0);
    setFpy(0);
    setFile("");
    setSSIdx(-1);
    setSSObjs({});
    setSharePressed(false);
    setAddress("No Address");
  }

  const onSharePressed = () => {
      setSharePressed(true);
  }

  const onPreviewLink = () => {

  }

 const removeNotUsedSS = () => {
    let keyDeleted = false;
    for (let key in ssObjs) {
      let ssObj = ssObjs[key];
      if (ssObj.coordinatex === 0 && ssObj.coordinatey === 0) {
        // snapshot was not positioned therefore remove from fp
        delete ssObjs[key];
        keyDeleted = true;
      }
    }
    // if (keyDeleted) {
    //   setSSObjs(JSON.parse(JSON.stringify(ssObjs)));
    // }
  }

  const onPayment = async () => {
    setLoading(true);
    if(!Security.valEmailInput(email)) {
      onNotify();
      setLoading(false);
      return;
    }
    const stripe = await loadStripe(stripeProductKey);
    let fpObj = new Floorplan (-1, fpBase64, "", "", "", "", fpOgWidth, fpOgHeight, false, snapSize);
    // remove any snapshots that have not been positioned on the floor plan
    removeNotUsedSS();
    fpObj.snapshots = ssObjs;
    setLoading(true);
    Network.stripeCheckoutSession (email, 0, fpObj, address, function (err, session) {
      if (err) {
        console.log("error during checkout");
        console.log(err);
        setLoading(false);
      } else {
        if(session && session.id) {
          const result = stripe.redirectToCheckout ({
            sessionId: session.id
          });
        }
        setLoading(false);
      }
    });
  }

  const getSSWidth = (ssId) => {
    let ssWidth;
    let ss = ssObjs[ssId];
    if (ssDoubleClicked==ssId || selectedCoord[`coordX: ${ss.coordinatex} coordY: ${ss.coordinatey}`] == 1) {
      ssWidth = ssObjs[ssId].renderWidth*windowWidth*0.4;
    } else {
      ssWidth = fpWidth*windowWidth*snapSize;
    }
    return ssWidth;
  }

  const getSSHeight = (ssId) => {
    let ssHeight;
    let ss = ssObjs[ssId];
    if (ssDoubleClicked==ssId || selectedCoord[`coordX: ${ss.coordinatex} coordY: ${ss.coordinatey}`] == 1) {
      ssHeight = ssObjs[ssId].renderHeight*windowHeight*0.4;
    } else {
      ssHeight = fpWidth*windowWidth*snapSize; // using width here is correct to make square icons
    }
    return ssHeight;
  }

  const handleRightClick = (event) => {
    if (event.type === 'contextmenu') {
      setSelectedSS(0);
    }
  }

  const handleDragLeave = event => {
    event.stopPropagation();
    event.preventDefault();
    // Bring the endzone back to normal, maybe?
  };
  const handleDragOver = event => {
    event.stopPropagation();
    event.preventDefault();
    // Turn the endzone red, perhaps?
  };
  const handleDragEnter = event => {
    event.stopPropagation();
    event.preventDefault();
    // Play a little sound, possibly?
  };
  const handleDrop = event => {
    event.stopPropagation();
    event.preventDefault();
    // ssObjs[selectedSS].coordinatex = (event.pageX-(fpX*windowWidth)-(getSSWidth()/2))/(fpWidth*windowWidth);
    // ssObjs[selectedSS].coordinatey = (event.pageY-(fpY*windowHeight)-(getSSHeight()/2))/(fpHeight*windowHeight);
    // setSSObjs({...ssObjs});
  };

  const imageDragEnd = (event, ssId) => {
    imageDrag(event, ssId);
  }

  const imageDragStart = (event, ssId) => {
    // imageDrag(event, ssId);
    setSelectedSS(ssId);
  }

  const imageDrag = (event, ssId) => {
    // console.log(`coordx: ${(event.pageX-(fpX*windowWidth))/(fpWidth*windowWidth)}`);
    // console.log(`coordy: ${(event.pageY-(fpY*windowHeight))/(fpHeight*windowHeight)}`);
    // ssObjs[ssId].coordinatex = (event.pageX-(fpX*windowWidth)-(getSSWidth()/2))/(fpWidth*windowWidth);
    // ssObjs[ssId].coordinatey = (event.pageY-(fpY*windowHeight)-(getSSHeight()/2))/(fpHeight*windowHeight);
    // setSSObjs({...ssObjs});
    let coordX = (event.pageX-(fpX*windowWidth)-(getSSWidth(selectedSS)/2))/(fpWidth*windowWidth);
      let coordY = (event.pageY-(fpY*windowHeight)-(getSSHeight(selectedSS)/2))/(fpHeight*windowHeight);
      console.log(`coordx: ${(event.pageX-(fpX*windowWidth))/(fpWidth*windowWidth)}`);
      console.log(`coordy: ${(event.pageY-(fpY*windowHeight))/(fpHeight*windowHeight)}`);
      const [x,y] = checkIfInRadius(coordX, coordY);
      if (x !== -1) {
        coordX = x;
        coordY = y;
      }
      if (coordMap[`coordX: ${ssObjs[ssId].coordinatex} coordY: ${ssObjs[ssId].coordinatey}`]) {
        coordMap[`coordX: ${ssObjs[ssId].coordinatex} coordY: ${ssObjs[ssId].coordinatey}`] = 
        coordMap[`coordX: ${ssObjs[ssId].coordinatex} coordY: ${ssObjs[ssId].coordinatey}`] - 1;
        galMap[`coordX: ${ssObjs[ssId].coordinatex} coordY: ${ssObjs[ssId].coordinatey}`].pop();
      }
      ssObjs[ssId].coordinatex = coordX;
      ssObjs[ssId].coordinatey = coordY;
      if (coordMap[`coordX: ${coordX} coordY: ${coordY}`]) {
        coordMap[`coordX: ${coordX} coordY: ${coordY}`] = coordMap[`coordX: ${coordX} coordY: ${coordY}`] + 1;
        galMap[`coordX: ${coordX} coordY: ${coordY}`].push({original: getImageSrc(ssObjs[ssId]), ssId: ssId});
      } else {
        coordMap[`coordX: ${coordX} coordY: ${coordY}`] = 1;
        galMap[`coordX: ${coordX} coordY: ${coordY}`] = [{original: getImageSrc(ssObjs[ssId]), ssId: ssId}];
        selectedCoord[`coordX: ${coordX} coordY: ${coordY}`] = 0;
      }
      setGalMap({...galMap});
      setCoordMap({...coordMap});
      setSelectedCoord({...selectedCoord});
      console.log(coordMap);
      setSSObjs({...ssObjs});
      genMapOfX(ssObjs);
  }

  const onDoubleClick = (ssId) => {
    const ss = ssObjs[ssId];
    console.log(ssId);
    setSSDoubleClicked(ssId);
    setSelectedSS(0);
    if (ss.coordinatex != 0 || ss.coordinatey != 0) {
      setSelectedCoord({...selectedCoord, [`coordX: ${ss.coordinatex} coordY: ${ss.coordinatey}`]: 1});
    }
  }

  const onLargeImageClick = (ssId) => {
    console.log("in large iamge click")
    const ss = ssObjs[ssId];
    console.log(ssId);
    setSSDoubleClicked(0);
    if (ss.coordinatex != 0 || ss.coordinatey != 0) {
      setSelectedCoord({...selectedCoord, [`coordX: ${ss.coordinatex} coordY: ${ss.coordinatey}`]: 0});
    }  
  }

  const onEmailChange = (email) => {
    setEmail(email.target.value);
    console.log(email.target.value);

  }

  const onAddressChange = (address) => {
    setAddress(address.target.value);
    console.log(address.target.value);

  }

  const onSmallPressed = () => {
    setSnapSize(0.025);
  }

  const onMedPressed = () => {
    setSnapSize(0.0375);

  }

  const onLargePressed = () => {
    setSnapSize(0.05);
  }

  const onNotify = () => {
    toast.error("Email Invalid", {
      position: "bottom-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    })
  }

  const getFpImageSrc = (base64, file) => {
    let imgSrc = "";
    if (base64) {
      switch (fpType) {
        case "png":
          imgSrc = "data:image/png;base64," + base64;
          break;
        case "jpeg":
          imgSrc = "data:image/jpeg;base64," + base64;
          break;
        default:
          break;
      }
      return imgSrc;
    } else {
      return "https://d1se9yqadop5at.cloudfront.net/" + file;
    }
  }

  const getImageSrc = (ssObj) => {
    if (ssObj.image) {
      // console.log(`ss base64 path: ${ssObj.snapshot_id}`)
      let base64Token = "";
      switch(ssObj.fileType) {
        case "jpeg":
          base64Token = "data:image/jpeg;base64,";
          break;
        case "png":
          base64Token = "data:image/png;base64,";
          break;
      }
      return base64Token + ssObj.image;
    } else {
      // console.log(`ss remote path: ${ssObj.remote_file_path}`)
      return "https://d1se9yqadop5at.cloudfront.net/" + ssObj.remote_file_path
    }
  }

  const onSubscribe = () => {
    setSubPlan(1);
    let fpObj = new Floorplan (-1, fpBase64, "", "", "", "", fpOgWidth, fpOgHeight, false, snapSize);
    removeNotUsedSS();
    fpObj.snapshots = ssObjs;
    setFpObj(fpObj);
    if (!user || (user && Object.keys(user).length == 0)) {
      setRegMode(true);
      navigate('/login');
    } else {
      Network.stripeCheckoutSession (user.email, 1, fpObj, address, async function (err, session) {
        if (err) {
          console.log("error during sub upgrade");
          console.log(err);
          setLoading(false);
        } else {
          const stripe = await loadStripe(stripeProductKey);
          if(session && session.id) {
            const result = stripe.redirectToCheckout ({
              sessionId: session.id
            });
          }
          setLoading(false);
        }
      });
    }
  }

  function slideLeft() {
    const curIdx = mapOfX[ssDoubleClicked];
    console.log(ssDoubleClicked);
    console.log(mapOfX);
    console.log(sortedByX);
    let newIdx = curIdx + 1;
    if (newIdx > sortedByX.length-1) {
      newIdx = 0;
    }
    const newSSId = sortedByX[newIdx].snapshot_id;
    let ss = ssObjs[newSSId];
    let oldSS = ssObjs[ssDoubleClicked];
    if (selectedCoord[`coordX: ${ss.coordinatex} coordY: ${ss.coordinatey}`] === 0 ) {
      selectedCoord[`coordX: ${oldSS.coordinatex} coordY: ${oldSS.coordinatey}`] = 0;
      selectedCoord[`coordX: ${ss.coordinatex} coordY: ${ss.coordinatey}`] = 1;
      setSelectedCoord({...selectedCoord});
    }
    console.log(ssObjs);
    console.log(newSSId);
    console.log(selectedCoord)
    setSSDoubleClicked(newSSId);
  }

  function slideRight() {
    const curIdx = mapOfX[ssDoubleClicked];
    console.log(curIdx);
    let newIdx = curIdx -1;
    if (newIdx < 0) {
      newIdx = sortedByX.length-1;
    }
    const ss = sortedByX[newIdx];
    const newSSId = ss.snapshot_id;
    const oldSS = sortedByX[curIdx];
    if (selectedCoord[`coordX: ${ss.coordinatex} coordY: ${ss.coordinatey}`] === 0 ) {
      selectedCoord[`coordX: ${oldSS.coordinatex} coordY: ${oldSS.coordinatey}`] = 0;
      selectedCoord[`coordX: ${ss.coordinatex} coordY: ${ss.coordinatey}`] = 1;
      setSelectedCoord({...selectedCoord});
    }
    console.log(newSSId);
    setSSDoubleClicked(newSSId);
  }

  const onAddProject = () => {
    let fpObj = new Floorplan (-1, fpBase64, "", "", "", "", fpOgWidth, fpOgHeight, false, snapSize);
    removeNotUsedSS();
    fpObj.snapshots = ssObjs;
    setLoading(true);
    Network.addProjectTier1 (user.email, "p", fpObj, address, function (err, serverProj) {
      if (err) {
        console.log("error during checkout"); 
        console.log(err);
        setLoading(false);
      } else {
        console.log(`server request to addProjectTier1 was successful.`);
        console.log(serverProj);
        let proj = serverProj.proj;
        let newProj = new Project(proj.server_project_id, "", address, "", {});
        const fpId = Object.keys(proj.floorplans)[0];
        console.log(fpId);
        const remote_path = String(proj.floorplans[fpId].image);
        let newFp = new Floorplan(fpId, "", "", "", "", remote_path, fpOgWidth, fpOgHeight, false, snapSize);
        newProj.floorplans = {[fpId]: newFp}
        console.log(`newProj value`);
        console.log(newProj);
        setUser({...user, projects: {...user.projects, [proj.server_project_id]: newProj}});
        resetCreateState();
        setLoading(false);
        navigate("/projectview");
      }
    });
  }

  const ArrowKeyDetector = (event) => {
    switch(event.key) {
      case 'ArrowRight':
        console.log("arrow right")
        slideLeft();
        break;
      case 'ArrowLeft':
        console.log("arrow left")
        slideRight();
        break;
      default:
        console.log(event.key)
        break;
    }
  }

  return (
    <div className="create">
      <Helmet>
        <meta charSet="utf-8" />
        <link rel="canonical" href="https://mapit.cc/create" />
      </Helmet>
      <PageTitle title="Upload Pictures and Floor Plans" />
      { !file && loading === false &&
      <div className="choose-file">
        <form>
          <input type="file" accept="image/jpeg,image/png,application/pdf" id="actual-btn" onChange={handleChange} hidden/>
          <label for="actual-btn">
            {/* <MapItButton onSubmit={()=>{}} text="Upload Floor Plan" className="upload-btn"/> */}
            <img 
            style={{height: 53, width: 169, cursor: 'pointer'}}
            alt="upload floor plan"
            src={uploadIcon}/>
          </label>
        </form>
      </div>
      }
      {!file && loading === true &&
        <div>
          <Loader.DotLoader
              color="#FCC81A"
              loading={loading}
              cssOverride={{position: "absolute", borderColor: "#FCC81A", marginLeft: "47vw", marginTop: "35vh"}}
              size={48}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
        </div>
      }
      { file && 
      <div className="edit-outter">
        <div className="snapshots">
          { !ssViewActive &&
         <div className="ss-inner">
         <div className="ss-contain">
           {Object.keys(ssObjs).map((ssId, index) => (
             ssId != ssDoubleClicked && !ssObjs[ssId].deleted
             && !selectedCoord[`coordX: ${ssObjs[ssId].coordinatex} coordY: ${ssObjs[ssId].coordinatey}`]
             ?
              <div className="ss-img">
                <img
                className={ssObjs[ssId].coordinatex==0&&ssObjs[ssId].coordinatey==0?"":"ss-img-img"}
                key={index} 
                src={getImageSrc(ssObjs[ssId])}
                alt="interior home picture"
                style={{
                  ...{border: ssId!==selectedSS?"1.5px solid black":"3px solid #FCC81A", 
                  cursor: "pointer",
                  opacity: ssId!==selectedSS?0.5:1,
                  width: getSSWidth(ssId), 
                  height: getSSHeight(ssId)}, 
                  ...getSnapshotStyle(ssId)}}
                onClick={() => imageClick(ssObjs[ssId], ssId)}
                onDragEnd={(event) => imageDragEnd(event, ssId)}
                onDragStart={(event) => imageDragStart(event, ssId)}
                onDoubleClick={(event) => onDoubleClick(ssId)}/>
              {coordMap[`coordX: ${ssObjs[ssId].coordinatex} coordY: ${ssObjs[ssId].coordinatey}`] 
              && coordMap[`coordX: ${ssObjs[ssId].coordinatex} coordY: ${ssObjs[ssId].coordinatey}`] > 1 
              &&
                <div>
                  <p className="count-style" style={{...getSnapshotCountStyle(ssId)}}>
                    {coordMap[`coordX: ${ssObjs[ssId].coordinatex} coordY: ${ssObjs[ssId].coordinatey}`]}
                  </p>
                </div>
                }
              </div>
             :
             ( ssId == ssDoubleClicked && selectedCoord[`coordX: ${ssObjs[ssId].coordinatex} coordY: ${ssObjs[ssId].coordinatey}`] == 1 && !ssObjs[ssId].deleted
             ?
             <div ref={galRef} style={{touchAction:'pinch-zoom', zIndex: 3}} className="ss-img">
               <img
               className="ss-img-img-large"
               key={index} 
               src={getImageSrc(ssObjs[ssId])}
               onClick={() => onLargeImageClick(ssId)}
               alt="interior home picture"
               style={{
                 ...{border: "1.5px solid black", 
                 cursor: "pointer",
                 opacity: 1,
                 zIndex: 3,
                 width: getSSWidth(ssId), 
                 height: getSSHeight(ssId)},  
                 ...getSnapshotStyle(ssId)}}
               />
               <div className='arrow-image' 
               onClick={slideRight}
               onKeyDown={ArrowKeyDetector} 
               style={{...{position: 'absolute', zIndex: 4, cursor: 'pointer'}, ...getLeftArrowStyle(ssId)}}>
                 <img src={left}
                 style={{width: ((getSSWidth(ssId)*0.1>40)?40:getSSWidth(ssId)*0.1),
                 height: getSSWidth(ssId)*0.1*1.74>69?69:getSSWidth(ssId)*0.1*1.74,
                 position: 'absolute', 
                 top: "50%", 
                 left: "50%", 
                 transform: "translate(-50%,-50%)"}}
                 />
               </div>
                 <div className='arrow-image-hover' 
                 onClick={slideRight}
                 onKeyDown={ArrowKeyDetector} 
                 style={{...{position: 'absolute', zIndex: 4, cursor: 'pointer'}, ...getLeftArrowStyle(ssId)}}>
                   <img src={leftBlue}
                   style={{width: ((getSSWidth(ssId)*0.1>40)?40:getSSWidth(ssId)*0.1),
                   height: getSSWidth(ssId)*0.1*1.74>69?69:getSSWidth(ssId)*0.1*1.74,
                   position: 'absolute', 
                   top: "50%", 
                   left: "50%", 
                   transform: "translate(-50%,-50%)"}}
                   />
                 </div>
               
               <div className='arrow-image' 
               onClick={slideLeft} 
               style={{...{position: 'absolute', zIndex: 4, cursor: 'pointer'}, ...getRightArrowStyle(ssId)}}>
                 <img src={right}
                 style={{width: ((getSSWidth(ssId)*0.1>40)?40:getSSWidth(ssId)*0.1),
                 height: getSSWidth(ssId)*0.1*1.74>69?69:getSSWidth(ssId)*0.1*1.74,
                 position: 'absolute', 
                 top: "50%", 
                 left: "50%", 
                 transform: "translate(-50%,-50%)"}}
                 />
               </div>
                 <div className='arrow-image-hover' 
                 onClick={slideLeft} 
                 style={{...{position: 'absolute', zIndex: 4, cursor: 'pointer'}, ...getRightArrowStyle(ssId)}}>
                   <img src={rightBlue}
                   style={{width: ((getSSWidth(ssId)*0.1>40)?40:getSSWidth(ssId)*0.1),
                   height: getSSWidth(ssId)*0.1*1.74>69?69:getSSWidth(ssId)*0.1*1.74,
                   position: 'absolute', 
                   top: "50%", 
                   left: "50%", 
                   transform: "translate(-50%,-50%)"}}
                   />
                 </div>
               
             </div>
             :
             (selectedCoord[`coordX: ${ssObjs[ssId].coordinatex} coordY: ${ssObjs[ssId].coordinatey}`] == 1
             ?
             <div ref={galRef} className="ss-img-img" style={{touchAction:'pinch-zoom', zIndex: 3,opacity: 0}}>
               <img
               className="ss-img-img-large"
               key={index} 
               src={getImageSrc(ssObjs[ssId])}
               onClick={() => onLargeImageClick(ssId)}
               alt="interior home picture"
               style={{
                 ...{border: "1.5px solid black", 
                 cursor: "pointer",
                 opacity: 0,
                 width: getSSWidth(ssId), 
                 height: getSSHeight(ssId)},  
                 ...getSnapshotStyle(ssId)}}
               />
               <div className='arrow-image' 
               onClick={slideRight} 
               style={{...{position: 'absolute', cursor: 'pointer',zIndex: 4,opacity: 0}, ...getLeftArrowStyle(ssId)}}>
                 <img src={left}
                 style={{width: ((getSSWidth(ssId)*0.1>40)?40:getSSWidth(ssId)*0.1),
                 height: getSSWidth(ssId)*0.1*1.74>69?69:getSSWidth(ssId)*0.1*1.74,
                 position: 'absolute', 
                 top: "50%", 
                 left: "50%", 
                 transform: "translate(-50%,-50%)"}}
                 />
               </div>
                 <div className='arrow-image-hover' 
                 onClick={slideRight} 
                 style={{...{position: 'absolute', cursor: 'pointer', zIndex: 4,opacity: 0}, ...getLeftArrowStyle(ssId)}}>
                   <img src={leftBlue}
                   style={{width: ((getSSWidth(ssId)*0.1>40)?40:getSSWidth(ssId)*0.1),
                   height: getSSWidth(ssId)*0.1*1.74>69?69:getSSWidth(ssId)*0.1*1.74,
                   position: 'absolute', 
                   top: "50%", 
                   left: "50%", 
                   transform: "translate(-50%,-50%)"}}
                   />
                 </div>
               
               <div className='arrow-image'
               onClick={slideLeft} 
               style={{...{position: 'absolute', cursor: 'pointer', zIndex: 4,opacity: 0}, ...getRightArrowStyle(ssId)}}>
                 <img src={right}
                 style={{width: ((getSSWidth(ssId)*0.1>40)?40:getSSWidth(ssId)*0.1),
                 height: getSSWidth(ssId)*0.1*1.74>69?69:getSSWidth(ssId)*0.1*1.74,
                 position: 'absolute', 
                 top: "50%", 
                 left: "50%", 
                 transform: "translate(-50%,-50%)"}}
                 />
               </div>
                 <div className='arrow-image-hover' 
                 onClick={slideLeft} 
                 style={{...{position: 'absolute', cursor: 'pointer', zIndex: 4,opacity: 0}, ...getRightArrowStyle(ssId)}}>
                   <img src={rightBlue}
                   style={{width: ((getSSWidth(ssId)*0.1>40)?40:getSSWidth(ssId)*0.1),
                   height: getSSWidth(ssId)*0.1*1.74>69?69:getSSWidth(ssId)*0.1*1.74,
                   position: 'absolute', 
                   top: "50%", 
                   left: "50%", 
                   transform: "translate(-50%,-50%)"}}
                   />
                 </div>
               
             </div>
             :
             <div ref={galRef} style={{touchAction:'pinch-zoom', zIndex: 3}} className="ss-img">
              <img
              className="ss-img-img-large"
              key={index} 
              src={getImageSrc(ssObjs[ssId])}
              onClick={() => onLargeImageClick(ssId)}
              alt="interior home picture"
              style={{
                ...{border: "1.5px solid black", 
                borderRadius: "5px", 
                cursor: "pointer",
                opacity: 1,
                zIndex: 3,
                width: getSSWidth(ssId), 
                height: getSSHeight(ssId)},  
                ...getSnapshotStyle(ssId)}}
              />
             </div>
             )
             )           
           ))}
         </div>
         <div className="size-btn-div">
           <div className="size-btn-div-inner">
             <MapItButton btnRef={btnRef} onSubmit={onSmallPressed} text="Small" className="sizebtn"/>
           </div>
           <div className="size-btn-div-inner">
             <MapItButton btnRef={btnRef} onSubmit={onMedPressed} text="Medium" className="sizebtn"/>
           </div>
           <div className="size-btn-div-inner">
             <MapItButton btnRef={btnRef} onSubmit={onLargePressed} text="Large" className="sizebtn"/>
           </div>
         </div>
       </div>
        }
        </div>
        <div ref={fpRef} className="floorplan"           
          onDragOver={(event) => handleDragOver(event)}
          onDragEnter={(event) => handleDragEnter(event)}
          onDragLeave={(event) => handleDragLeave(event)}
          onDrop={(event) => handleDrop(event)}>
          { !ssViewActive
          ? <img src={getFpImageSrc(fpBase64, "")} 
          width={fpWidth*windowWidth} 
          height={fpHeight*windowHeight} 
          onClick={(event) => fpClick(event)} 
          onContextMenu={(event) => fpClick(event)}
          alt="listing floor plan"/>
          : <img src={ssObjs[selectedSS].local_file_path} 
          width={ssObjs[selectedSS].width*windowWidth} 
          height={ssObjs[selectedSS].height*windowHeight}
          alt="listing floor plan"/>
          }
          <Loader.DotLoader
          color="#FCC81A"
          loading={loading}
          cssOverride={{position: "absolute", borderColor: "#FCC81A", zIndex: 1}}
          size={48}
          aria-label="Loading Spinner"
          data-testid="loader"
          />
        </div>
        <div className="edit-btns">
          <div className="edit-btn">
            <form>
              <label className="label-btn" for="edit-fp">Change Floor Plan</label>
              <input ref={btnRef} type="file" id="edit-fp" hidden onChange={handleChange}/>
            </form>
          </div>
          <div className="snap-btn">
            <form>
              <label className="label-btn" for="ss-btn">Upload Property Photos</label>
              <input ref={btnRef} type="file" accept="image/png,image/jpg,image/jpeg" id="ss-btn" hidden multiple onChange={handleMultipleChange}/>
            </form>
          </div>
          <div className="snap-menu">
            { selectedSS !== 0 && 
              <>
              {/* {ssViewActive &&
                <div className="view-btn">
                  <MapItButton onSubmit={onBackSS} text="Back" className="viewbtn"/>
                </div>
              }
              {!ssViewActive &&
                <div className="view-btn">
                  <MapItButton btnRef={btnRef} onSubmit={onViewSS} text="View" className="viewbtn"/>
                </div>
              }
              {!ssViewActive &&
                <div className="view-btn">
                  <MapItButton btnRef={btnRef} onSubmit={onCanSS} text="Unselect" className="viewbtn"/>
                </div>
              } */}
              <div  className="view-btn">
                <MapItButton btnRef={btnRef} onSubmit={onDelSS} text="Delete" className="viewbtn"/>
              </div>
              </>
            }
          </div>
          <div className="share-btn">
            <MapItButton btnRef={btnRef} onSubmit={onSharePressed} text="Share" className="sharebtn"/>
          </div>
        </div>
      </div>
      }
      { sharePressed && 
        <div ref={popupRef} className="share-popup-outter">
          <div className="share-popup-inner">
            {/* <div className="share-popup-img">
              <img
              className="popup-image" 
              src={popupmedia}
              width={0.2*windowWidth}
              height={0.5*windowHeight}
              alt="Home virtual tour"/>
            </div> */}
            <div className="share-popup-text">
              <div className='popup-logo'>
                <img 
                  src="https://d13dvi4jdbb8bg.cloudfront.net/MapIt-Logo-768x292px.png" 
                  width="118.36vh" 
                  height="45vh"
                  alt="MapIt logo"
                />
              </div> 
              <div className="popup-text">         
                <p className="p-live">Smart Floor Plan</p>
                {/* <p className="p-share">Share your</p>
                <p className="p-share">interactive floor plan for</p> */}
              </div>
              <div className="popup-price">
                {/* <p className="p-price">$9.99</p> */}
                {/* <p className="p-share">(First time free)</p> */}
                <Link className="url-link-style" to="/preview" spy={true} smooth={true}>
                  <MapItButton onSubmit={() => setPreview(true)} text="URL Preview" className="urlbtn"/>
              </Link>
              </div>
              {/* <Link className="url-link-style" to="/preview" spy={true} smooth={true}>
                <MapItButton onSubmit={() => setPreview(true)} text="URL Preview" className="paypalbtn"/>
              </Link> */}
              <div className="popup-email">
                <div className="email-inner">
                  <label className="email-label" htmlFor="streetAddress">Property Address</label>
                  <input
                    className="email-input"
                    value={address}
                    type="text"
                    name="streetAddress"
                    id="streetAddress"
                    placeholder="Property Address"
                    onChange={onAddressChange}
                    autoComplete='street-address'
                  />
                </div>
                <div className="email-inner">
                  <label className="email-label" htmlFor="email-address">Email</label>
                  <input
                    className="email-input"
                    value={email}
                    type="email"
                    name="email-address"
                    id="email-address"
                    placeholder="jack@realtygroup.com"
                    onChange={onEmailChange}
                  />
                </div>
                {user && Object.keys(user).length && user.sub_plan != 0
                ?
                <div className="payment-div">
                  <MapItButton onSubmit={onAddProject} text="Add Project" className="payBtn"/>
                </div>
                :
                <div className="payment-div">
                  <MapItButton onSubmit={onSubscribe} text="Subscribe" className="paypalbtn"/>
                  <MapItButton onSubmit={onPayment} text="Single" className="paypalbtn"/>
                </div>
                }
              </div>
            </div>
          <Loader.DotLoader
            color="#FCC81A"
            loading={loading}
            cssOverride={{position: "absolute", borderColor: "#FCC81A", marginLeft: "18.5vw", marginTop: "24vh"}}
            size={48}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
          </div>
          <ToastContainer 
            position="bottom-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            theme="light"
          />
        </div>
      }
      <ToastContainer 
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        theme="light"
      />
    </div>
  );
}

export default Create;